import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';

import { handleRequest, handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { ENDPOINT, DEFAULT_HEADERS } from 'api/configuration.js';

class AceptAssetView extends PureComponent {
  state = {
    titulo: 'Aceptando activo',
    parrafo: 'espere por favor . . .',
  };
  componentDidMount = () => {
    const { token } = this.props.match.params;
    console.log('%c ' + token, 'background: #222; color: #bada55');

    const endpoint = ENDPOINT;
    // this.defaultHeaders = defaultHeaders;
    // this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    const ajax = axios.create({
      baseURL: endpoint,
      timeout: 30000,
    });

    ajax.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    const url = '/aceptAsset/' + token;
    return ajax
      .put(url)
      .then((response) => {
        if (response.data.message === 'success.asset_acepted')
          this.setState({ titulo: 'Has aceptado el activo con exito.', parrafo: '' });
        return response;
      })
      .then(handleApiSucess)
      .catch((error) => {
        this.setState({ titulo: 'Token invalido o ya usado.', parrafo: '' });
        handleApiError(error);
      });
  };
  render = () => {
    return (
      <div className="container">
        <div className="row">
          <div
            className="col align-self-center mt-5"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h1>{this.state.titulo}</h1>
          </div>
          <div
            className="col-12"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <p>{this.state.parrafo}</p>
          </div>
        </div>
      </div>
    );
  };
}

export default translate()(AceptAssetView);



// WEBPACK FOOTER //
// src/modules/employeeAssetAcept/index.js